export default __webpack_public_path__ + "static/media/GoldFrame02.067dc00f.png";